import { useContext, useEffect, useState } from 'react';
import '../css/user/edituser.css'; // Assuming you reuse this CSS or have a similar one
import { Dimcontext } from '../../context/pagecontext';
import { Button, Form, FormControl, FormGroup, FormLabel, Row, Col } from 'react-bootstrap';
import { MdClose, MdModeEdit, MdDomain, MdLocationOn, MdAccessTime, MdSettingsInputAntenna } from 'react-icons/md';
import api from '../../api';
import Swal from 'sweetalert2';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { Datacontext } from '../../context/dataContext';
import { ToastContainer } from 'react-toastify';

export const EditBranch = ({ set_edit, id, showToast, fetchBranches }) => {
    const { setDim } = useContext(Dimcontext);
    
    // Assuming you store branches in your Datacontext
    const { branches = [] } = useContext(Datacontext);

    const [isSubmitting, setIsSubmitting] = useState(false);

    // Branch State Initialized
    const [branchData, setBranchData] = useState({
        name: "", 
        lattitude: "", 
        longitude: "", 
        radius: "", 
        geofence: "enable", 
        shift: "1"
    });

    const handleeditclose = () => {
        set_edit(false);
        setDim(false);
    };

    // Fetch existing branch data on mount
    useEffect(() => { 
        const getBranchToEdit = (branchId) => {
            const data = branches.find(item => item.id === branchId);
            if (data) {
                setBranchData({
                    name: data.name || '',
                    lattitude: data.lattitude?.toString() || '',
                    longitude: data.longitude?.toString() || '',
                    radius: data.radius?.toString() || '',
                    geofence: data.geofence || 'enable',
                    shift: data.shift?.toString() || '1'
                });
            }
        };
        getBranchToEdit(id); 
    }, [id, branches]);

    const up = async (e) => {
        e.preventDefault();
        
        try {
            setIsSubmitting(true);

            // Clean data before sending
            const finalData = {
                name: branchData.name.trim(),
                lattitude: parseFloat(branchData.lattitude) || 0,
                longitude: parseFloat(branchData.longitude) || 0,
                radius: parseInt(branchData.radius) || 0,
                geofence: branchData.geofence,
                shift: branchData.shift
            };

            // Using PATCH method based on your previous Express router setup
            await api.patch(`/updatebranch/${id}`, finalData);
            
            Swal.fire({
                title: "Updated!",
                text: "Branch details successfully modified.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });

            setIsSubmitting(false);
            handleeditclose();
            if (fetchBranches) fetchBranches();
            
        } catch (err) { 
        setIsSubmitting(false);
        console.error("Branch Update Error:", err);
        
        // 1. Safely extract the data payload from Axios
        const errData = err.response?.data;

        // 2. Check for Joi's specific 'details' array first, then fall back
        const errorMessage = 
            errData?.details?.[0]?.message || // Handles raw Joi errors
            errData?.message ||               // Handles standard formatted backend errors
            errData?.error ||                 // Handles alternative formatting
            "Failed to update branch.";       // Final fallback

        // 3. Clean up the message to remove Joi's double quotes
        const cleanMessage = errorMessage.replace(/"/g, '');

        showToast(cleanMessage);
    }
    };

    return (
        <div className="edituser-card shadow-lg">
            <ToastContainer/>
            <div className="modal-header-custom">
                <div className="header-title">
                    <MdModeEdit className="me-2" />
                    <span>Modify Branch Details</span>
                </div>
                <button onClick={handleeditclose} className="btn-close-custom"><MdClose /></button>
            </div>

            <SimpleBar style={{ width: '100%', height: 'calc(80vh - 70px)' }} noScrollX>
                <Form onSubmit={up} className="p-4">
                    
                    {/* Section: Basic Details */}
                    <div className="form-section">
                        <h6 className="section-title"><MdDomain className="me-2"/>Basic Information</h6>
                        <Row className="g-3">
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Branch Name</FormLabel>
                                    <FormControl 
                                        required 
                                        value={branchData.name} 
                                        onChange={(e) => setBranchData({ ...branchData, name: e.target.value })} 
                                        placeholder="Enter branch name"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Location & Geofencing */}
                    <div className="form-section mt-4">
                        <h6 className="section-title"><MdLocationOn className="me-2"/>Location Settings</h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Lattitude</FormLabel>
                                    <FormControl 
                                        required 
                                        value={branchData.lattitude} 
                                        onChange={(e) => setBranchData({ ...branchData, lattitude: e.target.value.replace(/[^0-9.-]/g, "") })} 
                                        placeholder="e.g., 12.9716"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Longitude</FormLabel>
                                    <FormControl 
                                        required 
                                        value={branchData.longitude} 
                                        onChange={(e) => setBranchData({ ...branchData, longitude: e.target.value.replace(/[^0-9.-]/g, "") })} 
                                        placeholder="e.g., 77.5946"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Radius (in meters)</FormLabel>
                                    <FormControl 
    required 
    maxLength={3}
    value={branchData.radius} 
    onChange={(e) => setBranchData({ 
        ...branchData, 
        radius: e.target.value.replace(/\D/g, "").slice(0, 3) 
    })} 
    placeholder="e.g., 500"
/>
                                </FormGroup>
                            </Col>

                            <Col md={12}>
                                <FormGroup className="doc-collect-box mt-2">
                                    <FormLabel className="me-4 fw-bold mb-0"><MdSettingsInputAntenna className="me-1"/> Geofencing</FormLabel>
                                    <Form.Check 
                                        inline type="radio" label="Enable" name="geofence" value="enable" 
                                        onChange={(e) => setBranchData({ ...branchData, geofence: e.target.value })} 
                                        checked={branchData.geofence === 'enable'} 
                                    />
                                    <Form.Check 
                                        inline type="radio" label="Disable" name="geofence" value="disable" 
                                        onChange={(e) => setBranchData({ ...branchData, geofence: e.target.value })} 
                                        checked={branchData.geofence === 'disable'} 
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={12}>
                                <FormGroup className="doc-collect-box mt-2">
                                    <FormLabel className="me-4 fw-bold mb-0"><MdAccessTime className="me-1"/> Shift Schedule</FormLabel>
                                    <Form.Check 
                                        inline type="radio" label="Shift 1" name="shift" value="1" 
                                        onChange={(e) => setBranchData({ ...branchData, shift: e.target.value })} 
                                        checked={branchData.shift === '1'} 
                                    />
                                    <Form.Check 
                                        inline type="radio" label="Shift 2" name="shift" value="2" 
                                        onChange={(e) => setBranchData({ ...branchData, shift: e.target.value })} 
                                        checked={branchData.shift === '2'} 
                                    />
                                    <Form.Check 
                                        inline type="radio" label="Shift 3" name="shift" value="3" 
                                        onChange={(e) => setBranchData({ ...branchData, shift: e.target.value })} 
                                        checked={branchData.shift === '3'} 
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    <div className="footer-actions sticky-bottom bg-white p-3 border-top d-flex justify-content-end mt-3">
                        <Button variant="secondary" className="px-4 me-2" onClick={handleeditclose} disabled={isSubmitting}>Cancel</Button>
                        <Button type="submit" className="btn-submit px-5" disabled={isSubmitting}>
                            {isSubmitting ? 'Updating...' : 'Update Changes'}
                        </Button>
                    </div>
                </Form>
            </SimpleBar>
        </div>
    );
};